<button
    [hasIcon]="true"
    [title]="'common.jivo' | translate"
    lsLivechatButton
    lsUiButtonKind="primary"
    lsUiButtonPalette="accent-1"
    lsUiButtonSize="small"
>
    <ls-ui-icon
        height="24"
        src="support"
        width="24"
    ></ls-ui-icon>
</button>
